'use strict';

// https://262.ecma-international.org/6.0/#sec-isarray
module.exports = require('../helpers/IsArray');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2024/IsArray.js
// module id = 371
// module chunks = 1